import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

/**
 * Fetches a protected image via Bearer auth and turns it into a blob URL.
 * Props: path (storage path returned by upload endpoint)
 */
export default function AuthImage({ path, className = "", alt = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let revoked = false;
    let blobUrl = null;
    if (!path) return;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (revoked) return;
        blobUrl = URL.createObjectURL(res.data);
        setSrc(blobUrl);
      })
      .catch(() => setSrc(null));
    return () => {
      revoked = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  if (!src) {
    return <div className={`bg-[hsl(var(--muted))] animate-pulse ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
